import Button from 'react-bootstrap/esm/Button';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AppDispatch, RootState } from '../../app/store';
import LoadingIndicator from '../loading/LoadingIndicator';
import { useAuth } from '../signin/auth';
import EditMeasurement from './EditMeasurement';
import { writeMeasurement } from './measurementSlice';
import { MeasurementUpdate } from './types';

const RouteMeasurementCreate = () => {
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();

  const measurementStatus = useSelector((state: RootState) => state.measurement.status)
  const measurementError = useSelector((state: RootState) => state.measurement.error)

  const onSaveClicked = (m: MeasurementUpdate) => {
    if (auth.authToken) {
      dispatch(writeMeasurement({
        authToken: auth.authToken,
        measurement: m,
      }));
    } else {
      console.log('No auth token!');
    }
  }

  return (
    <>
      <Row className="justify-content-end">
        <Col sm="auto">
          <Link to="/measurements">
            <Button variant='secondary'>Cancel</Button>
          </Link>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          {measurementStatus === 'loading' && <LoadingIndicator />}
          {measurementError && <div>{measurementError}</div>}
          <EditMeasurement buttonLabel='Create measurement' onSave={onSaveClicked} />
        </Col>
      </Row>
    </>
  );
};

export default RouteMeasurementCreate;
